import { CHAT_AGENT } from 'chatspot-core/types/CopilotAssistantTypes';
export const transformCopilotSummaryToAssistant = copilotSummary => {
  return {
    type: CHAT_AGENT,
    name: copilotSummary.name || '',
    iconUrl: copilotSummary.icon,
    id: copilotSummary.id,
    welcomeMessage: copilotSummary.welcomeMessage || ''
  };
};
export const transformCopilotToCopilotSummary = copilot => {
  return Object.assign({
    id: copilot.customCopilotId
  }, copilot);
};